/* lib/reports/foodcostMeta.js — реестр типов мер, рисков, сценариев и
 * ограничений FC-оптимизации v2. id ОБЯЗАНЫ байт-в-байт совпадать с бэкендом
 * (backend/reports/foodcost_calc.py MEASURE_TYPES / RISKS / SCENARIO_IDS /
 * VARIANT_IDS / GOAL_KINDS / CONSTRAINT_VALUES) — это ключи measure_type/risk
 * в Report.result и фильтра рекомендаций по кликабельным тегам. */

import { fmt } from '../format.js';

export const FC_MEASURE = {
  purchase_price: {
    label: 'Закупочная цена', short: 'Закупка', tone: 'neutral', icon: 'tag',
    title: 'Снижение закупочной цены: другой поставщик, объём, спецификация',
  },
  substitute: {
    label: 'Замена ингредиента', short: 'Замена', tone: 'neutral', icon: 'refresh',
    title: 'Замена продукта на аналог или другой класс продукта',
  },
  reduce_grammage: {
    label: 'Граммовка', short: 'Граммовка', tone: 'neutral', icon: 'scale',
    title: 'Сокращение закладки ингредиента с компенсацией',
  },
  recompose: {
    label: 'Пересборка состава', short: 'Состав', tone: 'neutral', icon: 'layers',
    title: 'Пересборка состава блюда: убрать/уменьшить/заменить несколько позиций',
  },
  reassemble_pf: {
    label: 'Оптимизация п/ф', short: 'П/ф', tone: 'neutral', icon: 'box',
    title: 'Пересборка полуфабриката: дорогой компонент внутри п/ф',
  },
  change_tech: {
    label: 'Технология', short: 'Технология', tone: 'neutral', icon: 'utensils',
    title: 'Изменение техпроцесса: выход растёт или потери падают',
  },
  reduce_losses: {
    label: 'Потери', short: 'Потери', tone: 'neutral', icon: 'arrow-down',
    title: 'Уменьшение потерь на заготовке/хранении/порционировании',
  },
  raise_price: {
    label: 'Повышение цены', short: 'Цена', tone: 'info', icon: 'arrow-up',
    title: 'Повышение цены продажи — food cost падает без изменения рецептуры',
  },
};
export const FC_MEASURE_ORDER = [
  'purchase_price', 'substitute', 'reduce_grammage', 'recompose',
  'reassemble_pf', 'change_tech', 'reduce_losses', 'raise_price',
];

export const FC_RISK = {
  low: {
    label: 'низкий риск', short: 'низкий', tone: 'ok', icon: 'check',
    title: 'Гость не заметит изменения',
  },
  medium: {
    label: 'средний риск', short: 'средний', tone: 'warn', icon: 'alert-triangle',
    title: 'Заметно при внимательной дегустации — нужна проработка',
  },
  high: {
    label: 'высокий риск', short: 'высокий', tone: 'bad', icon: 'alert-circle',
    title: 'Меняет вкус или восприятие блюда — только с шеф-пробой',
  },
};
export const FC_RISK_ORDER = ['low', 'medium', 'high'];

export const FC_SCENARIO = {
  cost_reduction: { label: 'Снижение себестоимости', icon: 'arrow-down' },
  price_increase: { label: 'Повышение цены', icon: 'arrow-up' },
  combined: { label: 'Комбинированный', icon: 'chevrons-up-down' },
};

export const FC_VARIANT = {
  best_safe: {
    label: 'Безопасный', icon: 'check-circle', tone: 'ok',
    title: 'Минимум риска для вкуса и гостевого опыта',
  },
  best_effect: {
    label: 'Максимум эффекта', icon: 'analytics', tone: 'info',
    title: 'Максимальная экономия',
  },
  compromise: {
    label: 'Компромисс', icon: 'scale', tone: 'accent',
    title: 'Баланс между экономией и рисками',
  },
};
export const FC_VARIANT_ORDER = ['best_safe', 'compromise', 'best_effect'];

export const FC_GOAL = {
  target_fc: { label: 'Целевой food cost', fmt: (v) => `${v} %` },
  cost_to_rub: { label: 'Себестоимость порции до', fmt: (v) => fmt.money(Number(v)) },
  cost_minus_rub: { label: 'Снизить себестоимость на', fmt: (v) => fmt.money(Number(v)) },
  cost_minus_pct: { label: 'Снизить себестоимость на', fmt: (v) => `${v} %` },
  keep_price_margin: { label: 'Сохранить цену, улучшить маржу', fmt: () => '' },
  max_safe: { label: 'Максимально безопасная оптимизация', fmt: () => '' },
};

export const FC_CONSTRAINT_VALUE = {
  yes: { label: 'можно', tone: 'ok' },
  no: { label: 'нельзя', tone: 'bad' },
  limited: { label: 'ограниченно', tone: 'warn' },
  unknown: { label: 'не задано', tone: 'neutral' },
};

export const FC_CONSTRAINT_LABEL = {
  can_raise_price: 'Цена',
  can_change_composition: 'Состав',
  can_change_grammage: 'Граммовки',
  can_change_tech: 'Технология',
};

export const fcMeasure = (id) => FC_MEASURE[id]
  || { label: id, short: id, tone: 'neutral', icon: 'tag', title: '' };
export const fcRisk = (id) => FC_RISK[id] || FC_RISK.medium;
export const fcVariant = (id) => FC_VARIANT[id] || FC_VARIANT.compromise;
